import React from 'react';
import './Footer.css';

const footer = () => (
    <div className="card Footer">
        <div className="text-muted font-weight-bold" style={{ padding: "10px", alignItems: "center" }}>
        MaxBounty Inc.
        </div>
    </div>
);


export default footer;